import isWebAssemblyFeatureSupported from '@environment/webAssemblyFeatureSupport';

// A minimal module using every post-MVP feature the vendored tlottie builds need:
// bulk-memory (memory.copy), non-trapping float-to-int (i32.trunc_sat_f32_s) and
// sign-extension (i32.extend8_s). Both the SIMD and the no-SIMD build need exactly
// these, so a browser failing here cannot run either one.
const BASELINE_TEST_MODULE = new Uint8Array([
  0x00, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00,
  0x01, 0x05, 0x01, 0x60, 0x00, 0x01, 0x7f,
  0x03, 0x02, 0x01, 0x00,
  0x05, 0x03, 0x01, 0x00, 0x01,
  0x0a, 0x16, 0x01, 0x14, 0x00, 0x41, 0x00, 0x41, 0x00, 0x41, 0x00, 0xfc, 0x0a, 0x00, 0x00,
  0x43, 0x00, 0x00, 0x00, 0x00, 0xfc, 0x00, 0xc0, 0x0b
]);

const IS_WEB_ASSEMBLY_BASELINE_SUPPORTED = isWebAssemblyFeatureSupported(BASELINE_TEST_MODULE);

export default IS_WEB_ASSEMBLY_BASELINE_SUPPORTED;
